export enum ScriptName {
  LOTTIE_SCRIPT = 'lottie',
}
